import React from 'react';
import classnames from 'classnames';
import { string, bool } from 'prop-types';
import { LocaleSelectionModalEntry, STYLES } from '@fiverr-private/locale_settings';
import { transformCurrencies } from '../../../utils/currency';
import { HEADER_SOURCE, PACKAGE_CLASSNAME } from '../../../constants';
import { LINK_CLASSNAME, LINK_TITLE_CLASSNAME } from '../constants';
import { useHeaderContext } from '../../../modern/context/HeaderContext';

import '../LeanLocaleSettingsLink/style.scss';

const LocaleSettingsLink = ({ style = STYLES.LEAN_MENU, shortenedLabel = true }) => {
    const { locale, displayedLocale, supportedLanguages, user, abTests, currency, supportedCurrencies, rollouts } =
        useHeaderContext();
    const props = {
        locale,
        currency: currency?.code,
        displayedLocale,
        supportedCurrencies: transformCurrencies(supportedCurrencies),
        supportedLanguages,
        user,
        style,
        shortenedLabel,
        className: classnames(LINK_CLASSNAME),
        titleClassName: LINK_TITLE_CLASSNAME,
        modalClassName: PACKAGE_CLASSNAME,
        source: HEADER_SOURCE,
        abTests,
        rollouts,
    };

    return (
        <div className="lean-locale-settings">
            <LocaleSelectionModalEntry {...props} />
        </div>
    );
};

LocaleSettingsLink.propTypes = {
    className: string,
    style: string,
    shortenedLabel: bool,
};

export default LocaleSettingsLink;
